module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp1_3.ecac0730.png";